/**
 * The Fidèle collection page (brand/WEBSITE_DESIGN_v2.md § 4.2): the filter drawer, the in-page chips
 * and Sort. Filters run on the page (every collection fits on one page): any value within a group,
 * every group at once. One finish chosen shows every card in that finish. The film tiles step aside
 * while a filter is on, so the results read as one grid. Nothing is counted on screen.
 */
const root = document.querySelector('[data-fdl-coll]');

if (root) {
  const dialog = root.querySelector('[data-fdl-filter]');
  const openBtn = root.querySelector('[data-fdl-filter-open]');
  const badge = root.querySelector('[data-fdl-filter-n]');
  const items = [...root.querySelectorAll('[data-fdl-item]')];
  const tiles = [...root.querySelectorAll('[data-fdl-tile]')];
  const empty = root.querySelector('[data-fdl-empty]');
  const priceBox = root.querySelector('[data-fdl-price]');
  let chipFamily = '';

  const money = (cents) => {
    const n = Number(cents) / 100;
    return '$' + (Number.isInteger(n) ? String(n) : n.toFixed(2));
  };

  function state() {
    const s = { finish: [], top: [], family: [], color: [], min: null, max: null };
    if (!dialog) return s;
    for (const box of dialog.querySelectorAll('input[type="checkbox"]:checked')) s[box.name].push(box.value);
    if (priceBox) {
      const lo = priceBox.querySelector('input[name="price_min"]');
      const hi = priceBox.querySelector('input[name="price_max"]');
      const a = Math.min(Number(lo.value), Number(hi.value));
      const b = Math.max(Number(lo.value), Number(hi.value));
      if (a > Number(priceBox.dataset.min)) s.min = a;
      if (b < Number(priceBox.dataset.max)) s.max = b;
    }
    return s;
  }

  function apply() {
    const s = state();
    let active = 0;
    for (const k of ['finish', 'top', 'family', 'color']) active += s[k].length;
    if (s.min !== null || s.max !== null) active += 1;
    if (chipFamily) active += 1;

    let shown = 0;
    for (const el of items) {
      const finishes = (el.dataset.finish || '').split(' ');
      const ok =
        (!s.finish.length || s.finish.some((f) => finishes.includes(f))) &&
        (!s.top.length || s.top.includes(el.dataset.top)) &&
        (!s.family.length || s.family.includes(el.dataset.family)) &&
        (!s.color.length || s.color.includes(el.dataset.color)) &&
        (s.min === null || Number(el.dataset.price) >= s.min) &&
        (s.max === null || Number(el.dataset.price) <= s.max) &&
        (!chipFamily || el.dataset.family === chipFamily);
      el.hidden = !ok;
      if (ok) shown += 1;
    }
    for (const t of tiles) t.hidden = active > 0;
    if (empty) empty.hidden = shown > 0;

    // one finish chosen: every card shows that finish, and its link opens it (fidele-finish.js reads the same flag)
    const one = s.finish.length === 1 ? s.finish[0] : 'Yellow';
    if (one === 'White') document.documentElement.dataset.finish = 'White';
    else delete document.documentElement.dataset.finish;
    for (const link of root.querySelectorAll('a[data-url-white]')) {
      const href = one === 'White' ? link.dataset.urlWhite : link.dataset.urlYellow;
      if (href) link.setAttribute('href', href);
    }

    const filterCount = active - (chipFamily ? 1 : 0);
    if (badge) badge.hidden = filterCount === 0;
    if (openBtn) openBtn.toggleAttribute('data-active', filterCount > 0);
  }

  function clearAll() {
    if (dialog) {
      for (const box of dialog.querySelectorAll('input[type="checkbox"]')) box.checked = false;
      if (priceBox) {
        priceBox.querySelector('input[name="price_min"]').value = priceBox.dataset.min;
        priceBox.querySelector('input[name="price_max"]').value = priceBox.dataset.max;
        updatePrice();
      }
    }
    apply();
  }

  function updatePrice() {
    if (!priceBox) return;
    const lo = priceBox.querySelector('input[name="price_min"]');
    const hi = priceBox.querySelector('input[name="price_max"]');
    const a = Math.min(Number(lo.value), Number(hi.value));
    const b = Math.max(Number(lo.value), Number(hi.value));
    priceBox.querySelector('[data-fdl-pmin]').textContent = money(a);
    priceBox.querySelector('[data-fdl-pmax]').textContent = money(b);
  }

  openBtn?.addEventListener('click', () => {
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  });
  dialog?.querySelector('[data-fdl-filter-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog?.querySelector('[data-fdl-apply]')?.addEventListener('click', () => {
    apply();
    dialog.close();
  });
  for (const btn of root.querySelectorAll('[data-fdl-clear]')) {
    btn.addEventListener('click', () => {
      chipFamily = '';
      for (const c of root.querySelectorAll('[data-fdl-chip]')) c.setAttribute('aria-pressed', String(c.dataset.fdlChip === ''));
      clearAll();
    });
  }
  priceBox?.addEventListener('input', updatePrice);

  for (const chip of root.querySelectorAll('[data-fdl-chip]')) {
    chip.addEventListener('click', () => {
      chipFamily = chip.dataset.fdlChip || '';
      for (const c of root.querySelectorAll('[data-fdl-chip]')) c.setAttribute('aria-pressed', String(c === chip));
      apply();
    });
  }

  const sort = root.querySelector('[data-fdl-sort] select');
  sort?.addEventListener('change', () => sort.form.submit());
}
